/**
 * Client Modal Handler for Dashboard Event Creation
 * Manages the nested client creation modal within the event creation flow
 */

import { ModalManager } from '../utils/modalManager.js';

export class ClientModalHandler {
  constructor(clientModal, eventModal) {
    this.clientModal = clientModal;
    this.eventModal = eventModal;
    this.clientForm = null;
    this.clientSelect = null;
  }

  init() {
    if (!this.clientModal) return;

    this.clientForm = document.getElementById('new_client_form');
    this.clientSelect = document.getElementById('event_client_id');

    this.setupOpenHandlers();
    this.setupCloseHandlers();
    this.setupFormHandlers();
  }

  setupOpenHandlers() {
    const openBtn = document.getElementById('openNewClientModal');
    if (openBtn && !openBtn.dataset.listenerAttached) {
      openBtn.dataset.listenerAttached = 'true';
      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.show();
      });
    }
  }

  setupCloseHandlers() {
    const closeBtn = document.getElementById('closeNewClientModal');
    const cancelBtn = document.getElementById('cancelNewClient');
    const overlay = this.clientModal?.querySelector('.modal-overlay');

    const hideHandler = () => this.hide();

    if (closeBtn && !closeBtn.dataset.listenerAttached) {
      closeBtn.dataset.listenerAttached = 'true';
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        hideHandler();
      });
    }

    if (cancelBtn && !cancelBtn.dataset.listenerAttached) {
      cancelBtn.dataset.listenerAttached = 'true';
      cancelBtn.addEventListener('click', (e) => {
        e.preventDefault();
        hideHandler();
      });
    }

    if (overlay && !overlay.dataset.listenerAttached) {
      overlay.dataset.listenerAttached = 'true';
      overlay.addEventListener('click', hideHandler);
    }

    // Escape key handler
    if (!document.hasClientModalEscapeListener) {
      document.hasClientModalEscapeListener = true;
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.clientModal && !this.clientModal.classList.contains('hidden')) {
          hideHandler();
        }
      });
    }
  }

  setupFormHandlers() {
    if (!this.clientForm) return;

    if (this.clientForm.dataset.listenerAttached === 'true') return;
    this.clientForm.dataset.listenerAttached = 'true';

    this.clientForm.addEventListener('ajax:success', (event) => {
      const [data] = event.detail || [];
      const client = data || {};
      this.handleClientCreated(client);
      this.hide();
      this.clientForm.reset();
    });

    this.clientForm.addEventListener('ajax:error', (event) => {
      const [xhr] = event.detail || [];
      const message = this.extractErrorMessage(xhr) || 'Unable to create client. Please check the form.';
      alert(message);
    });
  }

  handleClientCreated(client) {
    if (!this.clientSelect || !client.id || !client.name) return;

    let option = this.clientSelect.querySelector(`option[value="${client.id}"]`);
    if (option) {
      option.text = client.name;
      option.selected = true;
    } else {
      option = new Option(client.name, client.id, true, true);
      this.clientSelect.appendChild(option);
    }

    this.clientSelect.dispatchEvent(new Event('change'));
  }

  extractErrorMessage(xhr) {
    if (xhr?.responseJSON?.errors) {
      return Object.values(xhr.responseJSON.errors).flat().join('\n');
    }
    return null;
  }

  show() {
    if (!this.clientModal) return;
    ModalManager.hide(this.eventModal);
    ModalManager.show(this.clientModal);
    this.clientModal.style.zIndex = '60';
  }

  hide() {
    if (!this.clientModal) return;
    ModalManager.hide(this.clientModal);
    this.clientModal.style.zIndex = '';
    ModalManager.show(this.eventModal);
  }
}

